import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import app from './modules/app';
import selector from './modules/selector';
import safety from './modules/safety-management';
import finacial from './modules/finacial-management';

Vue.use(Vuex);

// 检测state的修改是否来源于mutations（只在开发环境中调试，生产环境移除严格模式【会消耗性能】）
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
	state: {
		//
	},
	mutations: {
		//
	},
	actions: {
		//
	},
	modules: {
		user,
		app,
		selector,
		safety,
		finacial
	},
	strict: debug
});
